import { X } from "lucide-react";
import React, { useState } from "react";

const ReferModal = ({ isOpen, setIsOpen, data, setData }) => {
    const [showTimesInput, setShowTimesInput] = useState(
        data?.referralType === "multiple"
    );
    const [prizeType, setPrizeType] = useState(data?.prizeType || "amount");

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData({
            ...data,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleReferralTypeChange = (e) => {
        const value = e.target.value;
        setShowTimesInput(value === "multiple");
        setData({ ...data, referralType: value });
    };

    const handlePrizeTypeChange = (e) => {
        const value = e.target.value;
        setPrizeType(value);
        setData({ ...data, prizeType: value });
    };

    const handleToggleReferral = () => {
        setData({ ...data, isActive: !data.isActive, notifyUser: false });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Referral Data Submitted:", data);
        setIsOpen(false);
    };

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-40 z-[99999] flex flex-col justify-end items-center"
            onClick={() => setIsOpen(false)}
        >
            <div
                className="bg-white w-full max-h-[90vh] max-w-[600px] rounded-t-2xl shadow-xl p-5 overflow-y-auto transition-transform duration-300 animate-slide-up"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-gray-800">
                        Referral Settings
                    </h2>
                    <button
                        onClick={() => setIsOpen(false)}
                        className="text-gray-500 hover:text-red-500 text-sm font-medium"
                    >
                        <X />
                    </button>
                </div>

                <form className="space-y-4" onSubmit={handleSubmit}>
                    {/* Referral Type */}
                    <div>
                        <label className="block text-sm font-medium text-black mb-2">
                            Referral Usage
                        </label>
                        <div className="flex gap-4">
                            <label className="flex items-center gap-2 text-sm text-black">
                                <input
                                    type="radio"
                                    name="referralType"
                                    value="one"
                                    checked={data.referralType === "one"}
                                    onChange={handleReferralTypeChange}
                                    className="text-blue-600 focus:ring-blue-500"
                                />
                                One Time
                            </label>
                            <label className="flex items-center gap-2 text-sm text-black">
                                <input
                                    type="radio"
                                    name="referralType"
                                    value="multiple"
                                    checked={data.referralType === "multiple"}
                                    onChange={handleReferralTypeChange}
                                    className="text-blue-600 focus:ring-blue-500"
                                />
                                Multiple Time
                            </label>
                        </div>
                    </div>

                    {/* How many times */}
                    {showTimesInput && (
                        <div>
                            <label
                                htmlFor="referralTimes"
                                className="block text-sm font-medium text-black mb-2"
                            >
                                How Many Times
                            </label>
                            <input
                                type="number"
                                id="referralTimes"
                                name="referralTimes"
                                value={data.referralTimes || ""}
                                onChange={handleChange}
                                placeholder="Enter number of times"
                               className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                            />
                        </div>
                    )}

                    {/* Prize Type */}
                    <div>
                        <label className="block text-sm font-medium text-black mb-2">
                            Referral Prize
                        </label>
                        <div className="flex gap-4">
                            <label className="flex items-center gap-2 text-sm text-black">
                                <input
                                    type="radio"
                                    name="prizeType"
                                    value="amount"
                                    checked={prizeType === "amount"}
                                    onChange={handlePrizeTypeChange}
                                    className="text-blue-600 focus:ring-blue-500"
                                />
                                Amount
                            </label>
                            <label className="flex items-center gap-2 text-sm text-black">
                                <input
                                    type="radio"
                                    name="prizeType"
                                    value="percentage"
                                    checked={prizeType === "percentage"}
                                    onChange={handlePrizeTypeChange}
                                    className="text-blue-600 focus:ring-blue-500"
                                />
                                Percentage
                            </label>
                        </div>
                    </div>

                    {/* Prize Value */}
                    <div>
                        <label
                            htmlFor="prizeValue"
                            className="block text-sm font-medium text-black mb-2"
                        >
                            Enter Prize ({prizeType})
                        </label>
                        <input
                            type="number"
                            id="prizeValue"
                            name="prizeValue"
                            value={data.prizeValue || ""}
                            onChange={handleChange}
                            placeholder={`Enter ${prizeType}`}
                           className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                        />
                    </div>

                    {/* Start/Stop Toggle */}
                    <div>
                        <label className="block text-sm font-medium text-black mb-2">
                            Referral Status
                        </label>
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={data.isActive || false}
                                onChange={handleToggleReferral}
                                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <span
                                className={`text-sm font-semibold ${data.isActive ? "text-blue-600" : "text-gray-600"
                                    }`}
                            >
                                {data.isActive ? "Active" : "Stopped"}
                            </span>
                        </label>
                    </div>

                    {/* Notify User (only when stopped) */}
                    {!data.isActive && (
                        <div>
                            <label className="flex items-center gap-2 text-sm text-black">
                                <input
                                    type="checkbox"
                                    name="notifyUser"
                                    checked={data.notifyUser || false}
                                    onChange={handleChange}
                                    className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                />
                                Notify user when referral system is stopped
                            </label>
                        </div>
                    )}

                    {/* Actions */}
                    <div className="flex justify-end gap-3 pt-2 mt-5">
                        <button
                            type="button"
                            onClick={() => setIsOpen(false)}
                            className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm disabled:bg-blue-300 disabled:cursor-not-allowed"
                        >
                            Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );

};

export default ReferModal;
